import {useQuery} from '@tanstack/react-query';

import {GetListOutput, GetListParams, QueryOptionsForList} from '@shared/api';
import {getVideos} from '../api';
import {QUERY__VIDEOS} from '../queryKeys';
import {Video} from '../types';

export const useGetVideos = <SelectedData = GetListOutput<Video>>(
  params?: GetListParams,
  options?: QueryOptionsForList<Video, SelectedData>,
) => {
  return useQuery({
    queryKey: [QUERY__VIDEOS, params],
    queryFn: () => getVideos(params),
    ...options,
  });
};
